<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">
            {{
              isInstructor
                ? "My Assigned Classes"
                : isStudent
                ? "Class Availability"
                : "List of Classes"
            }}
          </h3>
        </div>
        <div
          class="col-auto float-right ml-auto"
          v-if="!isInstructor && !isStudent"
        >
          <button
            class="btn add-btn"
            @click="
              $router.push({
                name:
                  tokenObj.UserType == userTypeMainAdmin
                    ? 'mainAdminClassAdd'
                    : 'schoolAdminClassAdd',
              })
            "
          >
            <i class="fa fa-plus"></i>Add Class
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Search Filter -->
    <div class="row row-filter-1">
      <div
        class="form-group col-md-3"
        v-if="tokenObj.UserType == userTypeMainAdmin"
      >
        <label><b>School</b></label>
        <select class="form-control" v-model="schoolId">
          <option value>All</option>
          <option v-for="item in schools" :value="item.Id" :key="item.Id">
            {{ item.Name }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-9">
        <label><b>Class (Filter)</b></label>
        <div class="form-row">
          <div class="col-md-4">
            <select class="form-control" v-model="subjectName">
              <option value>All Class Subjects</option>
              <option
                v-for="(item, i) in displayedSubjects"
                :value="item"
                :key="i"
              >
                {{ item }}
              </option>
            </select>
          </div>
          <div class="col-md-4 mt-2 mt-md-0 mt-lg-0">
            <select class="form-control" v-model="subjectLevelName">
              <option value>All Subject Levels</option>
              <option
                v-for="(item, i) in displayedSubjectLevels"
                :value="item"
                :key="i"
              >
                {{ item }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-2 mt-md-0 mt-lg-0">
            <select class="form-control" v-model="duration">
              <option value>All Durations</option>
              <option
                v-for="(item, i) in durations"
                :value="item.Duration"
                :key="i"
              >
                {{ item.Duration }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row row-filter-2">
      <div class="form-group col-md-3">
        <label><b>Class Frequency (Filter)</b></label>
        <select class="form-control" v-model="frequency">
          <option value>All Frequencies</option>
          <option v-for="(item, i) in frequencies" :value="item" :key="i">
            {{ item }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-3">
        <label><b>Location (Filter)</b></label>
        <select class="form-control" v-model="locationId">
          <option value>All Locations</option>
          <option v-for="(item, i) in locations" :value="item.Id" :key="i">
            {{ item.Location }}
          </option>
        </select>
      </div>
      <div
        :class="isInstructor ? 'form-group col-md-3' : 'form-group col-md-4'"
      >
        <template v-if="isInstructor">
          <label><b>Availability (Filter)</b> </label>
          <select class="form-control" v-model="availability">
            <option value>Filter Availability</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </template>
        <template v-else>
          <label><b>Instructor Name</b></label>
          <input
            class="form-control"
            type="text"
            v-model="instructorName"
            maxlength="100"
          />
        </template>
      </div>
    </div>
    <div class="row row-filter-3">
      <div class="form-group col-md-4">
        <label><b>Commencement Date (Filter)</b></label>
        <div class="form-row">
          <div class="col-md-6">
            <label>Start Date</label>
            <input type="date" class="form-control" v-model="startDate" />
          </div>
          <div class="col-md-6 mt-2 mt-md-0 mt-lg-0">
            <label>End Date</label>
            <input
              type="date"
              class="form-control"
              v-model="endDate"
              :min="startDate"
            />
          </div>
        </div>
      </div>
      <div class="form-group col-md-8">
        <label><b>Class Time (Filter)</b></label>
        <div class="form-row">
          <div class="col-md-4">
            <label>Start Time</label>
            <div class="d-flex align-items-center">
              <input
                type="number"
                class="form-control fit-content"
                v-model="startTimeHour"
                max="12"
                min="1"
                maxlength="2"
                placeholder="00"
                :required="startTimeMinute != ''"
              />
              <span class="mx-1">:</span>
              <input
                type="number"
                class="form-control fit-content"
                v-model="startTimeMinute"
                max="59"
                min="0"
                maxlength="2"
                placeholder="00"
              />
              <select
                v-model="startTimePart"
                class="form-control ml-2 fit-content"
              >
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </div>
          </div>
          <div class="col-md-4 mt-2 mt-md-0 mt-lg-0">
            <label>End Time</label>
            <div class="d-flex align-items-center">
              <input
                type="number"
                class="form-control fit-content"
                v-model="endTimeHour"
                max="12"
                min="1"
                maxlength="2"
                placeholder="00"
                :required="endTimeMinute != ''"
              />
              <span class="mx-1">:</span>
              <input
                type="number"
                class="form-control fit-content"
                v-model="endTimeMinute"
                max="59"
                min="0"
                maxlength="2"
                placeholder="00"
              />
              <select
                v-model="endTimePart"
                class="form-control ml-2 fit-content"
              >
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </div>
          </div>
          <div class="col-md-3 mt-2 mt-md-0 mt-lg-0" v-if="isInstructor">
            <button class="btn btn-primary filter-btn" @click="search">
              View
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row row-filter-4" v-if="!isInstructor">
      <div class="form-group col-md-3">
        <label><b>Availability (Filter)</b> </label>
        <select class="form-control" v-model="availability">
          <option value>Filter Availability</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>
      <div class="form-group col-md-1">
        <button class="btn btn-primary filter-btn" @click="search">View</button>
      </div>
    </div>
    <!-- /Search Filter -->

    <!-- List and Calendar Format Toggle -->
    <div class="row row-filter-5">
      <div
        class="col-12 my-auto text-center text-lg-right text-md-right format-div"
      >
        <button
          title="List format"
          :class="format == 'list' ? 'btn bg-blue' : 'btn bg-white'"
          @click="showListFormat()"
        >
          <i class="fas fa-list-ul"></i>
        </button>
        <button
          title="Calendar format"
          :class="format == 'calendar' ? 'btn bg-blue' : 'btn bg-white'"
          @click="showCalendarFormat()"
        >
          <i class="far fa-calendar-alt"></i>
        </button>
      </div>
    </div>
    <!-- /List and Calendar Format Toggle -->

    <!-- Table Result -->
    <list-format
      v-if="format == 'list'"
      :schoolId="schoolId"
      :subjectName="subjectName"
      :subjectLevelName="subjectLevelName"
      :duration="duration"
      :frequency="frequency"
      :locationId="locationId"
      :availability="availability"
      :startDate="startDate"
      :endDate="endDate"
      :startTimeHour="startTimeHour"
      :startTimeMinute="startTimeMinute"
      :startTimePart="startTimePart"
      :endTimeHour="endTimeHour"
      :endTimeMinute="endTimeMinute"
      :endTimePart="endTimePart"
      :instructorName="instructorName"
      :key="counterList"
    ></list-format>
    <calendar-format
      v-if="format == 'calendar'"
      :schoolId="schoolId"
      :subjectName="subjectName"
      :subjectLevelName="subjectLevelName"
      :duration="duration"
      :frequency="frequency"
      :locationId="locationId"
      :availability="availability"
      :startDate="startDate"
      :endDate="endDate"
      :startTimeHour="startTimeHour"
      :startTimeMinute="startTimeMinute"
      :startTimePart="startTimePart"
      :endTimeHour="endTimeHour"
      :endTimeMinute="endTimeMinute"
      :endTimePart="endTimePart"
      :instructorName="instructorName"
      :key="counterCalendar"
    ></calendar-format>
    <!-- /Table Result -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import ListFormat from "./ClassListTableFormat.vue";
import CalendarFormat from "./ClassListCalendarFormat.vue";
export default {
  components: {
    ListFormat,
    CalendarFormat,
  },
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      userTypeStudent: config.USERTYPE_STUDENT,
      schoolId: "",
      schools: [],
      subjectName: "",
      subjects: [],
      subjectLevelName: "",
      subjectLevels: [],
      duration: "",
      durations: [],
      frequency: "",
      frequencies: [],
      locationId: "",
      locations: [],
      startDate: "",
      endDate: "",
      startTimeHour: "",
      startTimeMinute: "",
      startTimePart: "AM",
      endTimeHour: "",
      endTimeMinute: "",
      endTimePart: "AM",
      availability: "",
      instructorName: "",
      format: "list",
      counterList: 0,
      counterCalendar: 0,
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
    displayedSubjects() {
      if (this.schoolId || this.tokenObj.UserType != this.userTypeMainAdmin) {
        let schoolId =
          this.tokenObj.UserType != this.userTypeMainAdmin
            ? this.tokenObj.SchoolId
            : this.schoolId;
        let subjects = this.subjects.filter(
          (c) => c.SchoolId == schoolId || c.IsDefault == true
        );
        return [...new Set(subjects.map((c) => c.Name))];
      } else {
        return [...new Set(this.subjects.map((c) => c.Name))];
      }
    },
    displayedSubjectLevels() {
      if (this.schoolId || this.tokenObj.UserType != this.userTypeMainAdmin) {
        let schoolId =
          this.tokenObj.UserType != this.userTypeMainAdmin
            ? this.tokenObj.SchoolId
            : this.schoolId;
        let subjectLevels = this.subjectLevels.filter(
          (c) => c.SchoolId == schoolId || c.IsDefault == true
        );
        return [...new Set(subjectLevels.map((c) => c.Name))];
      } else {
        return [...new Set(this.subjectLevels.map((c) => c.Name))];
      }
    },
    isInstructor() {
      return (
        (this.tokenObj.UserType == this.userTypeInstructorSchoolAdmin ||
          this.tokenObj.UserType == this.userTypeInstructor) &&
        this.$route.path.includes("/instructor/") &&
        !this.$route.path.includes("/schooladmin/")
      );
    },
    isStudent() {
      return (
        this.tokenObj.UserType == this.userTypeStudent &&
        this.$route.path.includes("/student/")
      );
    },
  },
  watch: {
    schoolId(val) {
      if (val) {
        this.subjectName = "";
        this.subjectLevelName = "";
      }
    },
  },
  methods: {
    showListFormat() {
      this.format = "list";
      this.$store.state.classFilter.format = "list";
    },
    showCalendarFormat() {
      this.format = "calendar";
      this.$store.state.classFilter.format = "calendar";
    },
    getSchools() {
      API.school
        .getSchools({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.schools = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getSubjects() {
      API.subject
        .getSubjectsForClassFilter({
          Token: this.tokenObj.Token,
        })
        .then((response) => {
          if (response.data.success) {
            this.subjects = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getSubjectLevels() {
      API.class
        .getSubjectLevelsForClassFilter({
          Token: this.tokenObj.Token,
        })
        .then((response) => {
          if (response.data.success) {
            this.subjectLevels = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getDurations() {
      API.class
        .getDurationsForClassFilter({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.durations = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getFrequencies() {
      API.class
        .getFrequenciesForClassFilter({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.frequencies = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getLocations() {
      API.class
        .getClassLocations({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.locations = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    search() {
      //validation
      if (
        (this.startTimeHour != "" || this.startTimeMinute != "") &&
        (this.endTimeHour != "" || this.endTimeMinute != "")
      ) {
        let startTimeHour =
          this.startTimeHour != "" ? parseInt(this.startTimeHour) : 0;
        let startTimeMinute =
          this.startTimeMinute != "" ? parseInt(this.startTimeMinute) : 0;
        let totalStartTimeMinutes =
          (this.startTimePart == "AM"
            ? startTimeHour == 12
              ? 0
              : startTimeHour
            : startTimeHour < 12
            ? startTimeHour + 12
            : 12) *
            60 +
          startTimeMinute;

        let endTimeHour =
          this.endTimeHour != "" ? parseInt(this.endTimeHour) : 0;
        let endTimeMinute =
          this.endTimeMinute != "" ? parseInt(this.endTimeMinute) : 0;
        let totalEndTimeMinutes =
          (this.endTimePart == "AM"
            ? endTimeHour == 12
              ? 0
              : endTimeHour
            : endTimeHour < 12
            ? endTimeHour + 12
            : 12) *
            60 +
          endTimeMinute;

        if (totalEndTimeMinutes <= totalStartTimeMinutes) {
          this.$swal("End Time must be later than Start Time", {
            icon: "error",
          });
          return;
        }
      }
      //set the state from filter
      this.$store.state.classFilter.schoolId = this.schoolId;
      this.$store.state.classFilter.subjectName = this.subjectName;
      this.$store.state.classFilter.subjectLevelName = this.subjectLevelName;
      this.$store.state.classFilter.duration = this.duration;
      this.$store.state.classFilter.frequency = this.frequency;
      this.$store.state.classFilter.locationId = this.locationId;
      this.$store.state.classFilter.startDate = this.startDate;
      this.$store.state.classFilter.endDate = this.endDate;
      this.$store.state.classFilter.startTimeHour = this.startTimeHour;
      this.$store.state.classFilter.startTimeMinute = this.startTimeMinute;
      this.$store.state.classFilter.startTimePart = this.startTimePart;
      this.$store.state.classFilter.endTimeHour = this.endTimeHour;
      this.$store.state.classFilter.endTimeMinute = this.endTimeMinute;
      this.$store.state.classFilter.endTimePart = this.endTimePart;
      this.$store.state.classFilter.availability = this.availability;
      this.$store.state.classFilter.instructorName = this.instructorName;
      //show result
      if (this.format == "list") this.counterList++;
      else this.counterCalendar++;
    },
  },
  created() {
    //populate the filter from state
    let classFilter = this.$store.state.classFilter;
    if (!this.isInstructor && !this.isStudent) {
      this.schoolId = classFilter.schoolId;
      this.subjectName = classFilter.subjectName;
      this.subjectLevelName = classFilter.subjectLevelName;
      this.duration = classFilter.duration;
      this.frequency = classFilter.frequency;
      this.locationId = classFilter.locationId;
      this.startDate = classFilter.startDate;
      this.endDate = classFilter.endDate;
      this.startTimeHour = classFilter.startTimeHour;
      this.startTimeMinute = classFilter.startTimeMinute;
      this.startTimePart = classFilter.startTimePart;
      this.endTimeHour = classFilter.endTimeHour;
      this.endTimeMinute = classFilter.endTimeMinute;
      this.endTimePart = classFilter.endTimePart;
      this.availability = classFilter.availability;
      this.instructorName = classFilter.instructorName;
    }
    this.format = classFilter.format ? classFilter.format : "list";

    this.getSchools();
    this.getSubjects();
    this.getSubjectLevels();
    this.getDurations();
    this.getFrequencies();
    this.getLocations();
    if (this.format == "list") this.counterList++;
    else this.counterCalendar++;
  },
};
</script>

<style scoped>
.fit-content {
  max-width: fit-content;
}

.format-div {
  word-spacing: -10px;
}
.btn {
  border: 1px solid #ededed;
}
.bg-white {
  background-color: white;
  color: grey;
}
.bg-blue {
  background-color: #4b68e7;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/ClassList.vue